import { useEffect, useMemo, useState } from 'react'
import {
  addCustomEcommercePlatform,
  getEcommercePlatformSelectOptions,
  loadCustomEcommercePlatforms,
} from '@/constants/ecommercePlatforms'
import { SearchableCreatableField } from '@/components/shared/SearchableCreatableField'

type Props = {
  value: string
  onChange: (value: string) => void
  label?: string
  placeholder?: string
  className?: string
  compact?: boolean
  selectClassName?: string
  error?: string
}

export function EcommercePlatformField({
  value,
  onChange,
  label = 'Plataforma',
  placeholder = 'Buscar Shopify, VTEX… ou digitar outra',
  className,
  compact = false,
  selectClassName,
  error,
}: Props) {
  const [customPlatforms, setCustomPlatforms] = useState<string[]>(() => loadCustomEcommercePlatforms())

  useEffect(() => {
    setCustomPlatforms(loadCustomEcommercePlatforms())
  }, [])

  const options = useMemo(() => {
    return getEcommercePlatformSelectOptions(customPlatforms).filter(
      (item) => item !== 'Outra (informar)',
    )
  }, [customPlatforms])

  return (
    <SearchableCreatableField
      value={value}
      onChange={onChange}
      options={options}
      label={compact ? '' : label}
      placeholder={placeholder}
      hint={compact ? undefined : 'Busque na lista, digite o nome da plataforma ou adicione uma nova.'}
      error={error}
      className={className}
      inputClassName={compact ? selectClassName : undefined}
      findDuplicate={(name, list) =>
        list.find((item) => item.toLowerCase() === name.trim().toLowerCase()) ?? null
      }
      onPersistOption={(name) => {
        const result = addCustomEcommercePlatform(name)
        if (!result.ok) return result
        setCustomPlatforms(loadCustomEcommercePlatforms())
        return { ok: true as const }
      }}
    />
  )
}
